import React from 'react';
import { PhoneIcon, MailIcon, MapPinIcon } from 'lucide-react';
export function ContactCTA() {
  return <section id="contact" className="py-20 sm:py-24 lg:py-32 bg-stone-50" data-id="element-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-13">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-14">
          {/* Content */}
          <div data-id="element-15">
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-serif font-bold text-black mb-6" data-id="element-16">
              Let's Start Planning
            </h2>
            <div className="w-16 h-px bg-gray-400 mb-8" data-id="element-17"></div>
            <p className="text-gray-600 text-base leading-relaxed mb-8" data-id="element-18">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris.
            </p>

            <div className="space-y-4 mb-8" data-id="element-19">
              <div className="flex items-center gap-4" data-id="element-20">
                <PhoneIcon className="w-5 h-5 text-gray-700" data-id="element-21" />
                <span className="text-gray-700 text-sm" data-id="element-22">(555) 123-4567</span>
              </div>
              <div className="flex items-center gap-4" data-id="element-23">
                <MailIcon className="w-5 h-5 text-gray-700" data-id="element-24" />
                <span className="text-gray-700 text-sm" data-id="element-25">
                  hello@gardendalevenue.com
                </span>
              </div>
              <div className="flex items-center gap-4" data-id="element-26">
                <MapPinIcon className="w-5 h-5 text-gray-700" data-id="element-27" />
                <span className="text-gray-700 text-sm" data-id="element-28">
                  123 Garden Lane, Countryside, ST 12345
                </span>
              </div>
            </div>

            <a href="#contact" className="inline-block bg-black text-white px-8 py-4 text-sm tracking-widest hover:bg-gray-800 transition-colors" data-id="element-29">
              BOOK YOUR TOUR TODAY
            </a>
          </div>

          {/* Image */}
          <div data-id="element-30">
            <img src="https://images.unsplash.com/photo-1522413452208-996ff3f3e740?w=800&q=80" alt="Contact Gardendale Venue" className="w-full h-[500px] object-cover" data-id="element-31" />
          </div>
        </div>
      </div>
    </section>;
}